/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export const uiFormControlSurfaceClassName =
    'w-full h-10 rounded-lg border border-gray-300 bg-white text-gray-900 shadow-sm transition-colors dark:border-gray-800 dark:bg-gray-950 dark:text-gray-100'

export const uiFormControlFocusClassName =
    'focus:outline-none focus:border-cta-light dark:focus:border-cta-light focus-within:border-cta-light dark:focus-within:border-cta-light'

export const uiFormControlPlaceholderClassName =
    'placeholder:text-gray-500 dark:placeholder:text-gray-400'

export const uiFormControlDisabledClassName =
    'cursor-not-allowed !bg-gray-100 text-gray-600 border-gray-200 shadow-none placeholder:text-gray-400 dark:!bg-gray-900 dark:text-gray-400 dark:border-gray-800 dark:placeholder:text-gray-500'
